const clean = (value) => String(value ?? '').trim();

export const getShippingSupplierKey = (row = {}) => {
  const source = clean(
    row.SupplierSource ?? row.supplierSource ?? row.SupplierShipping?.SupplierSource
  ).toLowerCase();
  const id = clean(row.SupplierId ?? row.supplierId ?? row.SupplierShipping?.SupplierId);
  if (id) return `${source || 'supplier'}:${id}`;

  const name = clean(row.SupplierName ?? row.supplierName ?? row.SupplierShipping?.SupplierName)
    .toLowerCase();
  return name ? `legacy-name:${name}` : null;
};

export const deriveBulkShippingSelection = (shippingData = [], selectedKeys = [], getItemKey) => {
  const rows = Array.isArray(shippingData) ? shippingData : [];
  const selectableRows = rows.filter((row) => !row?.Approved && getShippingSupplierKey(row));
  const supplierCounts = selectableRows.reduce((counts, row) => {
    const supplierKey = getShippingSupplierKey(row);
    counts.set(supplierKey, (counts.get(supplierKey) || 0) + 1);
    return counts;
  }, new Map());
  const eligibleSupplierKeys = new Set(
    [...supplierCounts.entries()].filter(([, count]) => count >= 2).map(([key]) => key)
  );
  const selectedSet = new Set(selectedKeys);
  const selectedRows = rows.filter((row, index) => selectedSet.has(getItemKey(row, index)));
  const selectedSupplierKeys = new Set(selectedRows.map(getShippingSupplierKey).filter(Boolean));
  const activeSupplierKey = selectedSupplierKeys.size === 1
    ? [...selectedSupplierKeys][0]
    : null;

  return {
    supplierCounts,
    eligibleSupplierKeys,
    selectedRows,
    activeSupplierKey,
    bulkAvailable: eligibleSupplierKeys.size > 0,
    validBulkSelection:
      selectedRows.length >= 2 &&
      selectedSupplierKeys.size === 1 &&
      eligibleSupplierKeys.has(activeSupplierKey),
  };
};
